import { render, staticRenderFns } from "./ViewOrderUserDetailModal.vue?vue&type=template&id=16a66f90&"
import script from "./ViewOrderUserDetailModal.vue?vue&type=script&lang=js&"
export * from "./ViewOrderUserDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a66f90')) {
      api.createRecord('16a66f90', component.options)
    } else {
      api.reload('16a66f90', component.options)
    }
    module.hot.accept("./ViewOrderUserDetailModal.vue?vue&type=template&id=16a66f90&", function () {
      api.rerender('16a66f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/ViewOrderUserDetailModal.vue"
export default component.exports